// extracted by mini-css-extract-plugin
export default {"title":"PhoneInfoRow_title__Dwgfl","id":"PhoneInfoRow_id__I-Qp-","phone":"PhoneInfoRow_phone__eEn+k","badges":"PhoneInfoRow_badges__7SiFQ"};